/* eslint-disable jsx-a11y/label-has-associated-control */

import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router";

const ConnectedEstimateLink = ({ estimateId, estimateNumber, rowClassName, labelClassName }) => {
    const { lang } = global;

    if (!estimateId || !estimateNumber) return null;

    return (
        <div className={rowClassName}>
            <div className={labelClassName}>
                <label>{`${lang.t("Connected Estimate")} #`}&nbsp;</label>
                <Link to={`/payments/manualinvoice?estimate=true&id=${estimateId}`}>
                    {estimateNumber}
                </Link>
            </div>
        </div>
    );
};

ConnectedEstimateLink.propTypes = {
    estimateId: PropTypes.string.isRequired,
    estimateNumber: PropTypes.string.isRequired,
    rowClassName: PropTypes.string.isRequired,
    labelClassName: PropTypes.string.isRequired,
};

export default ConnectedEstimateLink;
